import axios from 'axios';
import { CONSUMER_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';
 


export const addBrandLocality = (data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL + '/api/secure/v1/brand-locality', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const updateBrandLocality = data => {
  return axios({
    method: 'post',
    url: CONSUMER_BASE_URL + '/api/secure/v1/brand-locality', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getBrandSearchLocality = (data) => {
  return axios({
    method: 'post',
    url: CONSUMER_BASE_URL + '/api/secure/v1/search-locality', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};





